export default {
  'app.settings.menuMap.security': 'Security Settings',
  'app.settings.menuMap.timezone': 'Timezone Settings',
  'app.settings.actions.modify': 'Modify',
  'app.settings.password.title': 'Login password',
  'app.settings.resetpassword.title': 'Reset login password',
  'app.settings.password.description': 'To ensure password security, please update it regularly!',
  'app.settings.paypass.title': 'Pay password',
  'app.settings.resetpaypass.title': 'Reset pay password',
  'app.settings.paypass.description': 'To ensure password security, please update it regularly!',
  'app.settings.secret.title': 'Google verification code',
  'app.settings.resetsecret.title': 'Reset google verification code',
  'app.settings.secret.description': 'Please keep your Google key safe!',

  'app.settings.menuMap.hashkey': 'Hash key settings',
  'app.settings.menuMap.rsakey': 'Rsa key settings',
  'app.settings.label.hashkey': 'Hash key',
  'app.settings.label.platformrsapublickey': 'Platform rsa public key',
  'app.settings.label.merchantrsapublickey': 'Merchant rsa public key',
  'app.settings.label.merchantrsaprivatekey': 'Merchant rsa private key',

  'app.settings.label.loginduration': 'Login duration',
  'app.settings.label.timezone': 'Timezone',
};